<a href="javascript:;"
   [ngClass]='{"students_wrapper-list-absent": isAbsent }' *ngIf="pupil.id == currentPupil.id" class="active">
  <span class='students_wrapper-list-index'>{{ index + 1 }}.</span>
  <span class='students_wrapper-list-fullname'>{{pupil.surname}} {{pupil.name}}</span>
</a>
<a href="javascript:;"
   [ngClass]='{"students_wrapper-list-absent": isAbsent }' *ngIf="pupil.id != currentPupil.id">
  <span class='students_wrapper-list-index'>{{ index + 1 }}.</span>
  <span class='students_wrapper-list-fullname'>{{pupil.surname}} {{pupil.name}}</span>
</a>
